import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { FDBox, FDPaper, FDStack } from '@facet-wealth/design';
import MemberDataCaptureContainer from 'Components/ComponentLibrary/Organisms/MemberDataCapture';
import RichTextDisplayPicker
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';

export default function MemberDataCaptureMessageContent({
  messageResource,
  onLoadComplete,
}) {
  const memberDataCaptureLink = messageResource
    .relationship(fr.relationships.memberDataCapture.name)
    ?.link('related');

  useComponentDidMount(async () => {
    onLoadComplete();
  });

  return (
    <FDBox width={'100%'}>
      <FDStack direction={'column'} spacing={2}>
        <RichTextDisplayPicker content={messageResource.attr('content')} resource={messageResource} />
        {memberDataCaptureLink && (
        <FDPaper
          maxWidth={600}
          width={'100%'}
          alignSelf={'center'}
          padding={200}
          appearance={'outlined'}
        >
          <MemberDataCaptureContainer link={memberDataCaptureLink} />
        </FDPaper>
        )}
        <div /> {/* add some bottom space */}
      </FDStack>
    </FDBox>
  );
}

MemberDataCaptureMessageContent.defaultProps = {
  onLoadComplete: noop,
};

MemberDataCaptureMessageContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};
